<div class="row" style="justify-content: space-between;">
  <h2>{{title | removeUnderscore}}</h2>
  @if (selected_groups) {
    <div style="width:300px;">
      <select-many-groups
        (selectionChangeComplete)="groupsSelected($event)"
        [value]="selected_groups"
        [custom_selected_filters]="custom_selected_filters"
        [custom_filters]="reverse_custom_selected_filters"
        [label]="'Select Groups'">
      </select-many-groups>
    </div>
  }
</div>

<div class="row end space-between medium-height">
  @if (dataSource) {
    <div class="table-filter">
      <input #relGroupFilter (keyup)="applyFilter.next(relGroupFilter.value)" [value]="filter_string" placeholder="Search groups"/>
    </div>
  }
  <mat-paginator showFirstLastButtons
    style="justify-self: flex-end;">
  </mat-paginator>
</div>
<div class="table-container">
  <table [dataSource]="dataSource"
    [matSortActive]="'name'"
    (matSortChange)="updateSort($event)"
    class="table user-table"
    mat-table matSort matSortDirection="asc">

    @for (column of columns; track column) {
      <ng-container [matColumnDef]="column">
        <th *matHeaderCellDef [mat-sort-header]="column" mat-header-cell>
          <ng-container>{{column | titlecaseForWire | removeUnderscore}}</ng-container>
        </th>
        <td *matCellDef="let element;"
          mat-cell
          style="text-align: left;border:none;">
          @if (['created_on', 'changed_on'].includes(column)) {
            {{element.attributes[column] | stringDate }}
          }
          @if (!['created_on', 'changed_on'].includes(column)) {
            {{element.attributes[column]}}
          }
        </td>
      </ng-container>
    }

    <ng-container>
      <tr *matHeaderRowDef="columns; sticky: true" mat-header-row></tr>
      <tr *matRowDef="let row; columns: columns;" mat-row></tr>
    </ng-container>
  </table>
</div>
